/**
 * Used to dynamically create Store modules and Api endpoints
 */

export default {
  contentTypes: [
    {
      name: 'commissionAgreement',
      endpoint: 'commission-agreement',
    },
    {
      name: 'allAgreements',
      endpoint: 'commission-agreement/all',
    },
    {
      name: 'properties',
      endpoint: 'properties/fulldetails',
    },
    {
      name: 'agreementPass',
      endpoint: 'commission-agreement/agreement-pass',
    },
    {
      name: 'searchWatch',
      endpoint: 'search-watch',
    },
    {
      name: 'buyOrderPass',
      endpoint: 'buyorders/buyorder-pass',
    },
  ],
};
